import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.SourceInformationLeadForm {
  return <Models.SourceInformationLeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'source-information-lead-store' })
export class SourceInformationLeadStore extends Store<Models.SourceInformationLeadForm> {
  constructor() {
    super(createInitialState());
  }
}
